import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';


@Component({
    selector: 'app-form-inline-error',
    templateUrl: './form-inline-error.component.html',
    styleUrls: ['./form-inline-error.component.scss']
})

export class FormInlineErrorComponent {
    @Input() public errorControlName!: UntypedFormControl;
    @Input() public isSubmitted!: boolean;
    @Input() public messageConfig!: {
        required: string;
        pattern?: string;
        minMax?:string;
        password?:string
    };
    @Input() public isEmpty!: boolean;
    @Input() public errors!: string[];
    @Input() public wrongAttempt!: number;

}
